import { visit } from "@hotwired/turbo"

// A Placements row's Status or Renew panel loads when it is first opened
// (2026-10-17). When that load fails, say so in plain words instead of
// Turbo's "Content missing" or a "Loading..." that never ends (committee
// 2026-10-17): a deploy restarting the server, an error page, or the Wi-Fi
// dropping. A signed-out session (the frame's request was sent on to the
// sign-in page) reloads Placements itself, so signing in comes back there
// instead of to a bare panel. A row that changed since the page loaded is
// answered by the server in its own frame (placements#panel), not here.
export const PANEL_FAILED = "This panel could not load. Reload the page to try again."

function isPanel(element) {
  return element instanceof Element && element.hasAttribute("data-placement-panel")
}

function sayFailed(frame) {
  const line = document.createElement("p")
  line.className = "spt-small"
  line.style.cssText = "margin: 0; color: var(--spt-error, #b91c1c);"
  line.textContent = PANEL_FAILED
  frame.replaceChildren(line)
}

if (!window.__placementPanelFrameGuard) {
  window.__placementPanelFrameGuard = true

  document.addEventListener("turbo:frame-missing", (event) => {
    if (!isPanel(event.target)) return
    event.preventDefault()
    if (event.detail.response.redirected) visit(window.location.href)
    else sayFailed(event.target)
  })

  document.addEventListener("turbo:fetch-request-error", (event) => {
    if (isPanel(event.target)) sayFailed(event.target)
  })
}
